import type { NativeBuildMetadata } from './src/BKBuildMetadataModule';

export type {
  NativeBuildMetadata,
  NativeBuildMetadataPlatform,
  NativeBuildMetadataSource,
} from './src/BKBuildMetadataModule';

export function getBuildMetadata(): NativeBuildMetadata {
  return {
    source: 'local',
    easBuildId: null,
    easBuildProfile: null,
    easBuildPlatform: null,
    easAppVersion: null,
    easAppBuildVersion: null,
    gitCommitHash: null,
  };
}
